import type { Asn, AsnLine, Receipt } from "./api";

export function canStartAsnReceipt(
  asn: Asn,
  lines: AsnLine[] | undefined,
  receipts: Receipt[] | undefined
): boolean {
  if (!["ARRIVED", "RECEIVING"].includes(asn.status)) return false;
  if (!lines || !receipts) return false;
  if (!lines.some((line) => Number(line.remainingQuantity) > 0)) return false;
  return !receipts.some((receipt) =>
    ["OPEN", "POSTING"].includes(receipt.status)
  );
}

export type StartReceiptErrorCode =
  | "receiptState"
  | "receiptAlreadyOpen"
  | "receiptConflict"
  | "receiptStart"
  | "apiDetail"
  | "apiMessage";

export function startReceiptError(error: unknown): {
  code: StartReceiptErrorCode;
  value?: string;
} {
  const apiError = error as {
    status?: number;
    detail?: string;
    message?: string;
  } | null;
  if (apiError?.status === 409) {
    const detail = apiError.detail ?? "";
    if (detail.includes("ARRIVED or RECEIVING")) {
      return { code: "receiptState" };
    }
    if (detail.includes("active receipt")) {
      return { code: "receiptAlreadyOpen" };
    }
    return detail
      ? { code: "apiDetail", value: detail }
      : { code: "receiptConflict" };
  }
  return apiError?.message
    ? { code: "apiMessage", value: apiError.message }
    : { code: "receiptStart" };
}
